export const AVAILABILITY = 'availability';
export const ONLINE_PURCHASE = 'online_purchase';
export const LIST_VISIBILITY = 'list_visibility';
export const LUX_PLUS_SCHEDULE = 'lux_plus';
